import { Box } from "@mui/material";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { NotificationForm } from "Components/Notifications/NotificationsManagement/NotificationForm/NotificationForm";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useResource, Resources } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

export const NewNotificationPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.NewNotification)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("notifications-management"),
      }}
    >
      <StyledPageWrapper>
        <Box className="left-content">
          <NotificationForm />
        </Box>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};
